// Design tokens (colors, fonts) used across the UI.
// Kept lowercase + non-nested to match existing usage T.colorKey throughout the app.

export const T = {
  cream:      "#fdf6ec",
  parchment:  "#fce8d5",
  terra:      "#6b3fa0",
  terraLight: "#a05a8b",
  sage:       "#6db87a",
  sageDark:   "#4caf66",
  sageLight:  "#a0b8a0",
  sagePale:   "#f9fff9",
  blush:      "#e86a8a",
  gold:       "#c8834a",
  goldPale:   "#fdf0e3",
  clay:       "#3d1e5c",
  ink:        "#3d1e5c",
  inkMid:     "#6b3fa0",
  inkLight:   "#b07a80",
  white:      "#ffffff",
  display:    "'Georgia', 'Times New Roman', serif",
  body:       "'Georgia', serif",
} as const;

export type Theme = typeof T;
